module.exports = __webpack_public_path__ + "static/media/susa.da64a9e4.jpeg";